import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import "./theme/grid.js";
import { useBreakpoint, Breakpoint } from "./hooks/useBreakpoint.js";
import "react";
import { AnalyticsId, IconSize } from "./constants.js";
import { I as Icon } from "./Icon.js";
import { L as LazyIcon } from "./LazyIcon.js";
import { T as Title } from "./Title.js";
import styles from "./components/HighlightPanel/styles.module.scss";
var HighlightPanelSize = /* @__PURE__ */ ((HighlightPanelSize2) => {
  HighlightPanelSize2["medium"] = "medium";
  HighlightPanelSize2["large"] = "large";
  HighlightPanelSize2["fluid"] = "fluid";
  return HighlightPanelSize2;
})(HighlightPanelSize || {});
const Wrapper = ({ className, size, children }) => /* @__PURE__ */ jsx("div", { className, "data-testid": "highlightpanel-wrapper", children: /* @__PURE__ */ jsx("div", { className: styles.highlightpanel__row, children: /* @__PURE__ */ jsx("div", { className: classNames(styles.highlightpanel__col, size === "medium" && styles["highlightpanel__col--offset"]), children }) }) });
const ContentWrapper = (props) => {
  const { children, className } = props;
  const contentWrapperClasses = classNames(styles["highlightpanel__content-wrapper"], className);
  return /* @__PURE__ */ jsx("div", { className: contentWrapperClasses, children: /* @__PURE__ */ jsx("div", { className: classNames(styles.highlightpanel__row), children }) });
};
const HighlightPanel = (props) => {
  const {
    children,
    color = "white",
    size = "medium",
    testId,
    svgIcon,
    htmlMarkup = "div",
    className,
    contentWrapperClassName,
    title,
    titleHtmlMarkup = "h2"
  } = props;
  const breakpoint = useBreakpoint();
  const containerClassName = classNames(
    styles[`highlightpanel--${color}`],
    styles[`highlightpanel--${size}`],
    svgIcon && styles["highlightpanel--has-icon"],
    { container: size === "medium" || size === "large" },
    className
  );
  const renderContent = () => {
    const titleElement = title && /* @__PURE__ */ jsx(Title, { testId: "titleId", htmlMarkup: titleHtmlMarkup, appearance: "title4", children: title });
    if (svgIcon) {
      const iconSize = size === "large" && breakpoint && breakpoint >= Breakpoint.md ? IconSize.Medium : IconSize.Small;
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs("div", { className: styles.highlightpanel__icon, children: [
          typeof svgIcon === "string" ? /* @__PURE__ */ jsx(LazyIcon, { iconName: svgIcon, size: iconSize }) : /* @__PURE__ */ jsx(Icon, { svgIcon, size: iconSize }),
          title && breakpoint < Breakpoint.md && /* @__PURE__ */ jsx("div", { className: styles["highlightpanel__title-wrapper"], children: titleElement })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: styles.highlightpanel__content, children: [
          title && breakpoint >= Breakpoint.md && /* @__PURE__ */ jsx("div", { className: styles["highlightpanel__title-wrapper"], children: titleElement }),
          children
        ] })
      ] });
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      title && /* @__PURE__ */ jsx("div", { className: styles.highlightpanel__content, children: /* @__PURE__ */ jsx("div", { children: titleElement }) }),
      children
    ] });
  };
  const CustomTag = htmlMarkup;
  const contentWrapperClasses = classNames(styles["highlightpanel__content-wrapper"], contentWrapperClassName);
  if (size === "medium") {
    return /* @__PURE__ */ jsx(Wrapper, { className: containerClassName, size, children: /* @__PURE__ */ jsx(CustomTag, { className: contentWrapperClasses, "data-testid": testId, "data-analyticsid": AnalyticsId.HighlightPanel, children: renderContent() }) });
  }
  if (size === "large" && svgIcon) {
    return /* @__PURE__ */ jsx(Wrapper, { className: containerClassName, size, children: /* @__PURE__ */ jsx(ContentWrapper, { className: contentWrapperClasses, children: /* @__PURE__ */ jsx(
      CustomTag,
      {
        className: classNames(styles.highlightpanel__col, styles["highlightpanel__col--large-with-icon"]),
        "data-testid": testId,
        "data-analyticsid": AnalyticsId.HighlightPanel,
        children: renderContent()
      }
    ) }) });
  }
  if (size === "large") {
    return /* @__PURE__ */ jsx(Wrapper, { className: containerClassName, size, children: /* @__PURE__ */ jsx(ContentWrapper, { className: contentWrapperClasses, children: /* @__PURE__ */ jsx(
      CustomTag,
      {
        className: classNames(styles.highlightpanel__col, styles["highlightpanel__col--offset"]),
        "data-testid": testId,
        "data-analyticsid": AnalyticsId.HighlightPanel,
        children: renderContent()
      }
    ) }) });
  }
  if (size === "fluid") {
    return /* @__PURE__ */ jsx(CustomTag, { className: containerClassName, "data-testid": testId, children: renderContent() });
  }
  return null;
};
export {
  HighlightPanel as H,
  HighlightPanelSize as a
};
//# sourceMappingURL=HighlightPanel.js.map
